module.exports = __webpack_public_path__ + "static/media/totalStreamingUsers.a3977576.svg";